import React from "react";
import { ElementComponentProps } from "elements/types";
import { ReferenceElement } from "records/Element";
import ReferenceReactive from "./ReferenceReactive";
import ReferenceOnApply from "./ReferenceOnApply";
import { extractOnApplyParameters } from "elements/utils";

function ReferenceContainer(props: ElementComponentProps<ReferenceElement>) {
	const { isOnApplyPropsProvided, requiredOnApplyProps } =
		extractOnApplyParameters(props);
	return isOnApplyPropsProvided ? (
		<ReferenceOnApply {...props} {...requiredOnApplyProps} />
	) : (
		<ReferenceReactive {...props} />
	);
}

export default React.memo(ReferenceContainer);
